import React, { useEffect, useState, useCallback, useRef } from "react";
import DataTable from "react-data-table-component";
import { LuArrowUpDown } from "react-icons/lu";
import "../assets/css/styles.css";
import Popover from "./popover";
import axiosInstance from "../services/axiosInstance";
import WorkflowSheet from "./workflowSheet";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import JobSheet from "./jobSheet";
import CheckinPopup from "../Popup/checkinPopup";
import ViewSheetPopup from "../Popup/viewSheetPopup";
import { PropagateLoader } from "react-spinners";
import Select from "react-dropdown-select";

const SortIcon = ({ sortDirection }) => {
  if (sortDirection === "asc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  if (sortDirection === "desc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  return (
    <LuArrowUpDown
      className="ml-1 !w-4 !h-5"
      style={{ color: "#EFEFEF", opacity: "1" }}
    />
  );
};

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#376EA4",
      color: "#FAFDFF",
      fontSize: "16px",
      fontFamily: "InterBold",
      textAlign: "left",
      padding: "15px",
      opacity: "1",
      position: "sticky",
      top: 0,
      zIndex: 10,
      "@media screen and (min-width: 1250px) and (max-width: 1600px)": {
        fontSize: "14px",
      },
    },
    hoverStyle: {
      color: "#FAFDFF",
      opacity: "1",
    },
  },
  rows: {
    style: {
      // cursor: "pointer",
      fontSize: "16px",
      color: "#828282",
      padding: "6px",
      backgroundColor: "rgba(252, 252, 252, 0.5)",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8)",
      borderTop: "1px solid rgba(239, 239, 239, 0.8)",
      // overflow: "hidden",
      "@media screen and (min-width: 1250px) and (max-width: 1600px)": {
        fontSize: "14px",
        padding: "4px 8px",
      },
    },
    highlightOnHoverStyle: {
      fontSize: "16px",
      color: "#202020",
      padding: "6px",
      backgroundColor: "#F4F9FF",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8)",
      borderTop: "1px solid rgba(239, 239, 239, 0.8)",
      "@media screen and (min-width: 1250px) and (max-width: 1600px)": {
        fontSize: "14px",
        padding: "4px",
      },
    },
  },
  table: {
    style: {
      display: "block",
      maxHeight: "calc(100vh - 330px)",
      height: "fit-content",
      overflowY: "auto",
      borderCollapse: "separate",
      borderSpacing: 0,
      "@media screen and (min-width: 1600px)": {
        maxHeight: "calc(100vh - 340px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 760px) and (max-width: 1250px)": {
        maxHeight: "calc(100vh - 330px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 768px) and (max-width: 1024px)": {
        maxHeight: "calc(100vh - 360px)",
        overflowX: "hidden",
      },
    },
  },
};

const formatDueDeliveryDate = (dueDeliveryDate) => {
  if (!dueDeliveryDate) return "";

  const date = new Date(dueDeliveryDate);

  // Extract day, month, hours, and minutes
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  // Format as dd.MM | HH:mm
  return `${day}.${month} | ${hours}:${minutes}`;
};

const DepartmentDashboardTable = () => {
  const [loading, setLoading] = useState(false);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [orders, setOrders] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [departmentList, setDepartmentList] = useState([]);
  const [departmentOrderList, setDepartmentOrderList] = useState([]);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [openCheckinPopup, setOpenCheckinPopup] = useState(false);
  const tableContainerRef = useRef(null);
  const [scrollableElement, setScrollableElement] = useState(null);
  const [wfSheetData, setWfSheetData] = useState({
    patientName: "",
    dentistName: "",
    geoCode: "",
    workTypeDescription: "",
    workTypeName: "",
    departments: [],
  });
  const [jobSheetData, setJobSheetData] = useState({
    patientName: "",
    dentistName: "",
    standard_Notes: "",
    individual_Notes: "",
    workTypeDescription: "",
    workTypeName: "",
  });
  const [teethPositions, setTeethPositions] = useState([]);
  const pageSize = 100;

  const HandleRemovePopUp = () => setOpenPopup(false);
  const HandleCloseCheckinPopup = () => setOpenCheckinPopup(false);

  const option_wf = {
    method: "open",
    resolution: Resolution.NORMAL,
    page: {
      margin: Margin.SMALL,
      format: "A6",
      orientation: "landscape",
    },
    canvas: { mimeType: "image/png", qualityRatio: 1 },
    overrides: { canvas: { useCORS: true } },
  };
  const option_js = {
    method: "open",
    resolution: Resolution.NORMAL,
    page: {
      margin: Margin.SMALL,
      format: "A4",
      orientation: "portrait",
    },
    canvas: { mimeType: "image/png", qualityRatio: 1 },
    overrides: { canvas: { useCORS: true } },
  };

  const getTargetElement1 = () => document.getElementById("work-flow-sheet");
  const getTargetElement2 = () => document.getElementById("job-sheet");

  const workflowSheetHandleClick = () => {
    setOpenPopup(true);
    setIsVisible(true);
    handleGeneratePDF1();
  };
  const jobSheetHandleClick = () => {
    setOpenPopup(true);
    setIsVisible(true);
    handleGeneratePDF2();
  };

  const handleGeneratePDF1 = () => {
    setTimeout(() => {
      generatePDF(getTargetElement1, option_wf);
      setIsVisible(false);
    }, 10);
  };
  const handleGeneratePDF2 = () => {
    setTimeout(() => {
      generatePDF(getTargetElement2, option_js);
      setIsVisible(false);
    }, 10);
  };

  const handlePreviewWorkflowSheet = async (row) => {
    try {
      const rowId = row.orderId;
      const response = await axiosInstance.post(
        "/api/order/previewWorkflowSheet",
        {
          OrderId: parseInt(rowId, 10),
        }
      );
      if (response) {
        setWfSheetData({
          patientName: response.patientName,
          dentistName: response.dentistName,
          geoCode: response.geoCode,
          workTypeDescription: response.workTypeDescription,
          workTypeName: response.workTypeName,
          departments: response.departments,
        });
        workflowSheetHandleClick();
      } else {
        alert("Failed to open pdf. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching workflow data:", error);
    }
  };

  const handlePreviewJobSheet = async (row) => {
    try {
      const rowId = row.orderId;
      const response = await axiosInstance.post(
        "/api/order/previewJobflowSheet",
        {
          OrderId: parseInt(rowId, 10),
        }
      );
      if (response) {
        setJobSheetData({
          patientName: response?.patientName,
          dentistName: response?.dentistName,
          standard_Notes: response?.standard_Notes || "",
          individual_Notes: response?.individual_Notes || "",
          workTypeDescription: response?.workTypeDescription || "",
          workTypeName: response?.workTypeName || "",
        });
        setTeethPositions(response?.teethPositions);
        jobSheetHandleClick();
      } else {
        alert();
      }
    } catch (error) {
      console.error("Error fetching workflow data:", error);
    }
  };

  const columns = [
    {
      name: "Praxis",
      id: "praxis",
      cell: (row) => (
        <div title={`Praxis: ${row.dentistDisplayName}`}>
          {row.dentistDisplayName}
        </div>
      ),
      selector: (row) => row.dentistDisplayName,
      sortable: true,
      sortFunction: (a, b) =>
        a.dentistDisplayName.localeCompare(b.dentistDisplayName),
    },
    {
      name: "Patient",
      cell: (row) => (
        <div title={`Patient: ${row.patientName}`}>{row.patientName}</div>
      ),
      selector: (row) => row.patientName,
      sortable: true,
      sortFunction: (a, b) => a.patientName.localeCompare(b.patientName),
    },
    {
      name: "Arbeitsart",
      cell: (row) => (
        <div title={`Arbeitsart: ${row.workTypeName}`}>{row.workTypeName}</div>
      ),
      selector: (row) => row.workTypeName,
      sortable: true,
      sortFunction: (a, b) => a.workTypeName.localeCompare(b.workTypeName),
    },
    {
      name: "Zahnzahl",
      width: "10%",
      cell: (row) => (
        <div title={`Zahnzahl: ${row.toothCount}`}>{row.toothCount}</div>
      ),
      selector: (row) => row.toothCount,
      sortable: true,
      sortFunction: (a, b) => a.toothCount.localeCompare(b.toothCount),
    },
    {
      name: "Time enter Department",
      id: "time-enter-department",
      cell: (row) => (
        <div
          title={`Time enter Department: ${formatDueDeliveryDate(
            row.departmentStartDateTime
          )}`}
        >
          {formatDueDeliveryDate(row.departmentStartDateTime)}
        </div>
      ),
      selector: (row) => row.departmentStartDateTime,
      sortable: true,
      format: (row) => formatDueDeliveryDate(row.departmentStartDateTime),
      sortFunction: (a, b) =>
        (a.departmentStartDateTime || "").localeCompare(
          b.departmentStartDateTime || ""
        ),
    },
    {
      name: "Time leave Department",
      cell: (row) => (
        <div
          title={`Time leave Department: ${formatDueDeliveryDate(
            row.departmentENDDateTime
          )}`}
        >
          {formatDueDeliveryDate(row.departmentENDDateTime)}
        </div>
      ),
      selector: (row) => row.departmentENDDateTime,
      sortable: true,
      format: (row) => formatDueDeliveryDate(row.departmentENDDateTime),
      sortFunction: (a, b) =>
        (a.departmentENDDateTime || "").localeCompare(
          b.departmentENDDateTime || ""
        ),
    },
    {
      name: "Vorschau",
      selector: (row) => row.create,
      sortable: false,
      width: "12.5%",
      cell: (row) => (
        <div className="flex items-center justify-center gap-2">
          {" "}
          {/* Center alignment */}
          <Popover
            trigger="hover"
            content={
              <p
                className="absolute -right-4 text-blue-400 px-2 py-0.5 3xl:py-1 leading-5 bg-blue rounded w-auto -top-7 text-lg xl:text-xs 3xl:text-lg whitespace-nowrap after:content-[' '] after:-bottom-2 after:right-7 after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-blue shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] max-w-fit"
                style={{}}
              >
                Auftragszettel
              </p>
            }
          >
            <button
              onClick={() => handlePreviewJobSheet(row)}
              className="rounded-lg p-1.5 w-10 h-10 border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)]"
              style={{
                backgroundColor: "rgba(201, 226, 252, 0.3)",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              <img src="./icons/Jobsheet.svg" className="mx-auto" />
            </button>
          </Popover>
          <Popover
            trigger="hover"
            content={
              <p
                className="absolute -right-1 text-blue-400 px-2 py-0.5 3xl:py-1 leading-5 bg-blue rounded w-auto -top-7 text-lg xl:text-xs 3xl:text-lg whitespace-nowrap after:content-[' '] after:-bottom-2 after:right-5 after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-blue shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] max-w-fit"
                style={{}}
              >
                Auftragsablauf
              </p>
            }
          >
            <button
              onClick={() => handlePreviewWorkflowSheet(row)}
              className="rounded-lg p-1.5 w-10 h-10 border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)]"
              style={{
                backgroundColor: "rgba(201, 226, 252, 0.3)",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              <img src="./icons/flowchart.svg" className="mx-auto" />
            </button>
          </Popover>
        </div>
      ),
      ignoreRowClick: true,
      allowoverflow: true,
      button: true,
    },
  ];

  const fetchAllAvailableOrders = (selectedDepartmentId) => {
    setOrders(
      departmentOrderList.filter(
        (x) => x.departmentId === selectedDepartmentId && x.orderId != null
      )
    );
  };

  const getDepartmentList = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        "/api/Order/getDepartmentWiseOrder"
      );
      if (response && response.isSuccess && Array.isArray(response?.data)) {
        setDepartmentOrderList(response.data);
        const departmentDetails = Object.values(
          response.data.reduce((acc, item) => {
            const { departmentId, departmentName, orderId, isOngoingOrder } = item;

            // if (!isOngoingOrder) return acc;

            if (!acc[departmentId]) {
              acc[departmentId] = {
                departmentId,
                departmentName,
                count: 0,
              };
            }

            if (orderId != null && isOngoingOrder) {
              acc[departmentId].count += 1;
            }

            return acc;
          }, {})
        )
          .sort((a, b) => a.departmentName.localeCompare(b.departmentName))
          .map((dept) => ({
            label:
              dept.count > 0
                ? `${dept.departmentName} (${dept.count})`
                : dept.departmentName,
            value: dept.departmentId,
          }));

        setDepartmentList(departmentDetails);
        setSelectedDepartmentId(departmentDetails[0]?.value);
      } else {
        setDepartmentList([]);
      }
    } catch (error) {
      setDepartmentList([]);
    }
  }, [axiosInstance]);

  useEffect(() => {
    getDepartmentList();
    const intervalId = setInterval(getDepartmentList, 30 * 60 * 1000); // 30 minutes

    return () => clearInterval(intervalId); // Cleanup interval on unmount
  }, [getDepartmentList]);

  useEffect(() => {
    setOrders([]);
    setPageNumber(1);
    setHasMore(true);
    fetchAllAvailableOrders();
  }, []);

  useEffect(() => {
    if (tableContainerRef.current && !loading) {
      const rdtTable = tableContainerRef.current.querySelector(".rdt_Table");
      if (rdtTable) {
        setScrollableElement(rdtTable);
      }
    }
  }, [loading]);

  return (
    <div>
      <style>
        {`
          #work-flow-sheet.hidden {
            display: none;
          }        
        `}
      </style>
      <div className="pt-4 mb-0 font-inter relative w-full sm:w-1/3">
        <Select
          className="appearance-none !border h-10 sm:h-12 xl:h-10 3xl:h-12 !border-gray !leading-relaxed text-base sm:!text-2xl xl:!text-sm 3xl:!text-2xl bg-white !rounded-lg w-full 2xl:min-w-[250px] py-2 sm:!py-3 px-3 sm:!px-5 text-gray-600 placeholder:text-base sm:placeholder:!text-2xl xl:placeholder:!text-sm 3xl:placeholder:!text-2xl placeholder:!text-gray-400 hover:!border-blue-600 focus:!border-blue-600 focus:!outline-none !shadow-none"
          options={departmentList}
          labelField="label"
          valueField="value"
          placeholder="Bitte Abteilung auswählen"
          values={departmentList?.filter(
            (item) => item?.value === selectedDepartmentId
          )}
          onChange={(selectedOptions) => {
            if (selectedOptions[0]?.value) {
              const selectedDepartmentId = selectedOptions[0]?.value;
              setSelectedDepartmentId(selectedDepartmentId);
              fetchAllAvailableOrders(selectedDepartmentId);
            }
          }}
        />
      </div>
      <div ref={tableContainerRef}>
        {" "}
        {/* Wrapper div for table and loader */}
        {loading ? (
          <div className="flex justify-center items-center min-h-60">
            <PropagateLoader color="rgb(55 110 164 / var(--tw-bg-opacity, 1))" />
          </div>
        ) : (
          <>
            <DataTable
              defaultSortFieldId="time-enter-department"
              defaultSortAsc={true}
              noDataComponent={
                <div className="py-4 text-gray-500">
                  Es sind keine Datensätze zum Anzeigen vorhanden
                </div>
              }
              className="production_order_tbl mt-5 !rounded-xl shadow-[0_0_8px_rgba(44,99,152,0.2)] font-interRegular"
              columns={columns}
              data={orders} 
              pagination={false}
              fixedHeader
              customStyles={customStyles}
              sortIcon={<SortIcon />}
              highlightOnHover={false}
            />
            {isFetchingMore && (
              <div className="flex justify-center items-center py-4">
                <PropagateLoader
                  color="rgb(55 110 164 / var(--tw-bg-opacity, 1))"
                  size={10}
                />
              </div>
            )}
            {/* <div className="text-end mt-4">
              <button
                className={`bg-blue text-2xl xl:!text-base 3xl:!text-2xl uppercase border border-gray-300 bg-gray-300 text-gray-500
                font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in`}
                type="button"
                onClick={downloadOrderReport}
              >
                {loading ? "Exportiert" : "Export"}
              </button>
            </div> */}
          </>
        )}
      </div>

      {/* modal popup */}
      <ViewSheetPopup openPopUp={openPopup} closePopUp={HandleRemovePopUp} />
      <CheckinPopup
        openPopUp={openCheckinPopup}
        closePopUp={HandleCloseCheckinPopup}
      />

      {/* work flow sheet */}
      <WorkflowSheet
        wfSheetData={wfSheetData}
        formatDueDeliveryDate={formatDueDeliveryDate}
        isVisible={isVisible}
      />

      {/* job sheet */}
      <JobSheet
        jobSheetData={jobSheetData}
        isVisible={isVisible}
        toothGridData={teethPositions}
      />
    </div>
  );
};

export default DepartmentDashboardTable;
